import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ModalService } from '../../services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-partial-confirm-pop-up',
  templateUrl: './partial-confirm-pop-up.component.html',
  styleUrl: './partial-confirm-pop-up.component.scss'
})
export class PartialConfirmPopUpComponent implements OnInit {
  processLoading = false;
  progress_spinner = false;
  verifiedItems: any[] = [];

  constructor(public dialogRef: MatDialogRef<PartialConfirmPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private modalService: ModalService,
    private toastr: ToastrService,
    private formService: FormService,
    public helperService: HelperService,
  ) {

  }

  ngOnInit(): void {
    // Filter items that have added_rx_num
    this.verifiedItems = this.data?.item?.refill_request?.filter((item: any) => 
      item.added_rx_num && item.added_rx_num.toString().trim() !== ''
    ) || [];
  }


  openConfirmProcess(type?: string) {
    const sourceData = type;
    this.modalService.confirmRxAddProcessOrder(sourceData, (res: any) => {
      if (res.success == true) {
        this.renew_refill_process_order(res?.type);
      }
    });
  }

  // Proceed to create sales order after all Rx IDs are added
  renew_refill_process_order(type?: string) {
    // Get only verified Rx IDs from the drug list
    const rxValues = this.data?.item?.refill_request
      ?.filter((item: any) => item.added_rx_num && item.added_rx_num.toString().trim() !== '')
      .map((item: any) => item.added_rx_num) || [];

    // Get verified refill request IDs
    const refillRequestIds = this.data?.item?.refill_request
      ?.filter((item: any) => item.added_rx_num && item.added_rx_num.toString().trim() !== '')
      .map((item: any) => item.id) || [];

    const payload = {
      "user_id": this.data?.item?.user_id,
      "server_location": this.formService.selectedLocation.value,
      "search_value": rxValues,
      "sales_order_id": this.data?.item?.order_id,
      "refill_request_ids": refillRequestIds,
      "type": type || ''
    }
    this.processLoading = true;
    this.shippingService.renew_refill_process_order(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.processLoading = false;
          this.toastr.success('Refill process order renewed successfully');
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res?.body?.message || 'Failed to renew refill process order');
          this.processLoading = false;
        }
      },
      error: (err) => {
        console.error('error::', err);
        this.toastr.error(err?.message);
        this.processLoading = false;
        this.dialogRef.close(false);
      }
    });
  }

  //  Close modal dialog
  closeDialog(): void {
    this.dialogRef.close();
  }

}
